import { render } from "./GiftVouchersPayment.vue?vue&type=template&id=1d37fa06&scoped=true"
import script from "./GiftVouchersPayment.vue?vue&type=script&lang=js"
export * from "./GiftVouchersPayment.vue?vue&type=script&lang=js"

import "./GiftVouchersPayment.vue?vue&type=style&index=0&id=1d37fa06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d37fa06"]])

export default __exports__